/**
 * Calculates the opacity of a shadow based on Y position
 * The lower you scroll, the darker the shadow of DepartureSummary
 *
 * @param {Number} scrollPosition - window.OffSetY
 * @param {Number} offset - Maximum value it can go
 * @param {Number} time - Use offset/time to calculate the rate of the animation
 * @returns shadow opacity
 */
/* istanbul ignore next */
const getBoxShadowOpacity = (scrollPosition, offset, time) => {
  const rate = offset / time
  return scrollPosition * rate <= offset ? scrollPosition * rate : offset
}

/**
 * Calculates left or right margin value
 * The lower you scroll, the wider (higher margin) the DepartureSummary component
 *
 * @param {Number} scrollPosition - window.OffSetY
 * @param {Number} offset - Maximum value it can go
 * @param {Number} time - Use offset/time to calculate the rate of the animation
 * @returns left or right margin value
 */
/* istanbul ignore next */
const getDynamicMargin = (scrollPosition, offset, rate) => {
  return -scrollPosition * rate >= -offset ? -(scrollPosition * rate) + 'px' : -offset + 'px'
}

export { getBoxShadowOpacity, getDynamicMargin }
